import { RESET_FORM } from '../actionTypes';
import { locationFormActions } from '../reducer';

export default (name) => locationFormActions[RESET_FORM]({ name });
